// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SELLER_SEARCH_count_RESULT_REVIEWS = ["%(count)s hodnotenie", "%(count)s hodnotenia", "%(count)s hodnoten\u00ed"];
export const BZ2_SELLER_SEARCH_NO_RESULT_REVIEWS = "Bez hodnoten\u00ed";
